/**
 * Enum maintained by hand, BE is responding as a plain string.
 */
export enum VehicleEngineType {
  Thermal = 'Thermal',
  Electric = 'Electric',
  Gas = 'Gas',
  PluginHybrid = 'PluginHybrid',
}
